import AdminAddService from './AdminAddService';

export default AdminAddService;
